import { FC } from "react";
import classNames from "classnames";

import { Tooltip } from "../Tooltip";
import { SectionProps } from "./types";

import styles from "./Section.module.css";



const Section: FC<SectionProps> = ({
  children,
  className,
  icon,
  title,
  infoTooltip,
  headerRight,
}) => {
  const hasRightContent = headerRight ?? infoTooltip;

  return (
    <section className={classNames(styles["section"], className)}>
      {Boolean(title) && (
        <header className={styles["section__header"]}>
          <div className={styles["section__header_left"]}>
            {icon && <div className={styles["section__icon"]}>{icon}</div>}
            <h2 className={styles["section__title"]}>{title}</h2>
          </div>
          {hasRightContent && (
            <div className={styles["section__header_right"]}>
              {headerRight}
              {infoTooltip && (
                <Tooltip content={infoTooltip}>
                  <button type="button" className={styles["section__info"]}>
                    i
                  </button>
                </Tooltip>
              )}
            </div>
          )}
        </header>
      )}
      {children}
    </section>
  );
};

export default Section;

